import { PasswordInputProps } from "@mantine/core";
import noop from "lodash/noop";
import { Control, FieldValues, Path, useController } from "react-hook-form";

import { PasswordInput } from "#shared/view/components/PasswordInput";

interface Props<T extends FieldValues> extends PasswordInputProps {
  error?: string;
  label: string;
  required?: boolean;
  step?: string;
  rows?: number;
  control: Control<T>;
  name: Path<T>;
}

export const PasswordInputController = <T extends FieldValues>({
  name,
  error,
  label,
  control,
  ...props
}: Props<T>) => {
  const { field } = useController({ name, control });
  return <PasswordInput {...field} onBlur={noop} label={label} error={error} {...props} />;
};
